<template>
  <div>
    <main-layout>
      <v-tabs v-model="tabs" color="white" :slider-color="$store.state.theme.brand_color">
        <v-tab ripple :key="'Runner'" :href="'#Runner'">{{ $t('Runner') }}</v-tab>
        <v-tab ripple :key="'Participants'" :href="'#Participants'">{{ $t('Participants') }}</v-tab>
        <v-tab ripple :key="'Attachedrunningresult'" :href="'#Attachedrunningresult'">{{
          $t('Attached running result')
        }}</v-tab>
      </v-tabs>
      <div>
        <div v-if="tabs == 'Runner'">
          <Runner></Runner>
        </div>
        <div v-else-if="tabs == 'Participants'">
          <Participants></Participants>
        </div>
        <div v-else-if="tabs == 'Attachedrunningresult'">
          <Attachedrunningresult></Attachedrunningresult>
        </div>
      </div>
    </main-layout>
  </div>
</template>

<script>
import Attachedrunningresult from './Attachedrunningresult.vue'
import Participants from './Participants.vue'
import Runner from './Runner.vue'
export default {
  components: {
    Attachedrunningresult,
    Participants,
    Runner
  },
  data() {
    return {
      tabs: 'Runner'
    }
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      vm.tabs = vm.$route.query.tab
    } else {
      vm.tabs = 'Runner'
    }
  },
  methods: {},
  watch: {
    tabs: function () {
      //   this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/runkan/main.vue